import React from "react";
import {Button} from "react-bootstrap";
import {FaTextSlash} from "react-icons/fa6";
import {useTheCellMapContext} from "../contexts/TheCellMapContext";

const HideLabelToggleButton = () => {
  const {settings, setSetting} = useTheCellMapContext();

  return (
    <Button
      id="setting-hide-labels"
      active={settings.hideNodeLabels}
      aria-label="Hide node labels"
      title="Hide node labels"
      variant="outline-light"
      onClick={() => setSetting("hideNodeLabels", !settings.hideNodeLabels)}>
      {/*flip icon around so it's the same orientation as our labels*/}
      <FaTextSlash className="ui-icon"/>
    </Button>
  );
};

export default HideLabelToggleButton;
